// src/components/DraggableLocation.js
import React, { useRef } from "react";
import Draggable from "react-draggable";
import { Box, Paper, Typography, IconButton } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import RestaurantIcon from '@mui/icons-material/Restaurant';

function DraggableLocation({
  location,
  orders = [],
  onDragStop,
  isOccupied = false,
  onViewDetails,
}) {
  const nodeRef = useRef(null);
  const defaultPosition = { x: location.x || 0, y: location.y || 0 };

  const handleStop = (e, data) => {
    onDragStop(location.id, data.x, data.y);
  };

  const dragHandleClassName = `drag-handle-${location.id}`;

  const handleDetailsClick = (e, orderId) => {
    e.stopPropagation();
    if (onViewDetails) {
      onViewDetails(orderId);
    }
  };

  return (
    <Draggable
      nodeRef={nodeRef}
      bounds="parent"
      defaultPosition={defaultPosition}
      onStop={handleStop}
      handle={`.${dragHandleClassName}`}
    >
      <Paper
        ref={nodeRef}
        elevation={3}
        sx={{
          position: "absolute",
          width: location.width || 100,
          height: location.height || 70,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "default",
          backgroundColor: isOccupied ? "#ffcdd2" : "#e8f5e9",
          border: isOccupied ? "2px solid #ef5350" : "2px solid #66bb6a",
          transition: "background-color 0.3s ease",
          zIndex: isOccupied ? 10 : 5,
          padding: 0.5,
        }}
      >
        {isOccupied && (
          <Box
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: "error.main",
            }}
          />
        )}

        <Typography
          variant="body2"
          fontWeight="bold"
          color={isOccupied ? "error" : "success.dark"}
          sx={{ mt: 1 }}
        >
          {location.name}
        </Typography>

        <Box sx={{ display: "flex", gap: 0.5, mt: "auto" }}>
          <IconButton
            className={dragHandleClassName}
            aria-label="arrastrar mesa"
            size="small"
            sx={{
              cursor: "grab",
              backgroundColor: "rgba(0,0,0,0.05)",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.1)",
              },
              "&:active": {
                cursor: "grabbing",
              },
            }}
          >
            <DragIndicatorIcon fontSize="small" />
          </IconButton>

          {isOccupied && Array.isArray(orders) &&
            orders.map((order) => (
              <IconButton
                key={order.id}
                aria-label="ver detalles"
                size="small"
                onClick={(e) => handleDetailsClick(e, order.id)}
                sx={{
                  backgroundColor: "rgba(0,0,0,0.05)",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.1)",
                  },
                  cursor: "pointer",
                }}
              >
                <RestaurantIcon fontSize="small" />
              </IconButton>
            ))}
        </Box>
      </Paper>
    </Draggable>
  );
}

export default DraggableLocation;